module.exports = __webpack_public_path__ + "img/Const-Logo.ebeb5767.png";